const $ = require("jquery")
import icons from "../icons/icons"
import Swiper, { Navigation } from "swiper"
Swiper.use([Navigation])
import "swiper/swiper-bundle.css"
import ClipboardJS from "clipboard"
import validate from "jquery-validation"
import Inputmask from "inputmask"
import Cropper from "cropperjs"
import "cropperjs/src/css/cropper.css"

// vars
if ($("#uploadphoto").length > 0) {
  let result = document.querySelector(".result"),
    save = document.querySelector(".save"),
    cropped = document.querySelector(".js-add-bg-photo"),
    upload = document.querySelector("#uploadphoto"),
    cropper = ""

  // on change show image with crop options
  upload.addEventListener("change", (e) => {
    if (e.target.files.length) {
      const reader = new FileReader()
      reader.onload = (e) => {
        if (e.target.result) {
          $(".js-crop-modal").addClass("active")
          let img = document.createElement("img")
          img.id = "image"
          img.src = e.target.result
          result.innerHTML = ""
          result.appendChild(img)
          save.classList.remove("hide")
          cropper = new Cropper(img, {
            zoomOnWheel: true,
            dragMode: "move",
            aspectRatio: 4 / 4,
            autoCropArea: 0.65,
            restore: false,
            guides: false,
            center: false,
            highlight: false,
            cropBoxMovable: true,
            cropBoxResizable: false,
            toggleDragModeOnDblclick: false,
          })
        }
      }
      reader.readAsDataURL(e.target.files[0])
    }
  })

  save.addEventListener("click", (e) => {
    e.preventDefault()
    let imgSrc = cropper
      .getCroppedCanvas({
        width: "150",
      })
      .toDataURL()
    cropped.style.backgroundImage = `url('${imgSrc}')`
    $(".upload-img-for-backend").val(imgSrc)
  })
  $(".js-close-crop-modal").on("click", function () {
    $(".js-crop-modal").removeClass("active")
  })
}

// if ($(".phoneMaskOne").length > 0) {
//   var selector = document.querySelector(".phoneMaskOne");
//   Inputmask({ mask: "(+99)(999) 999 99 99" }).mask(selector, {});
// }
// if ($(".phoneMaskTwo").length > 0) {
//   var selector = document.querySelector(".phoneMaskTwo");
//   Inputmask({ mask: "(+99)(999) 999 99 99" }).mask(selector, {});
// }
// if ($(".ibanMask").length > 0) {
//   var selector = document.querySelector(".ibanMask");

//   Inputmask({ mask: "AA99 9999 9999 9999 9999 9999 99" }).mask(selector);
// }
$.validator.addClassRules({
  vsurname: {
    required: true,
  },
  vname: {
    required: true,
  },
  vPhoneNumber: {
    required: true,
  },
  vCompanyNumber: {},
  vmail: {
    required: true,
    email: true,
  },
  vpassword: {
    required: true,
  },
  vrePassword: {
    required: true,
  },
})
window.onload = function () {
  setTimeout(() => {
    document.querySelector(".preloader").classList.add("hidden")
  }, 250)
}

$.extend($.validator.messages, {
  required: "Bu alan zorunludur.",
  remote: "Bu alanı lütfen düzeltin.",
  email: "Email adresini yanlış girdiniz.",
  url: "Please enter a valid URL.",
  date: "Lütfen geçerli bir tarih giriniz.",
  dateISO: "Please enter a valid date (ISO).",
  number: "Sadece rakam girebilirsiniz.",
  digits: "Please enter only digits.",
  creditcard: "Please enter a valid credit card number.",
  equalTo: "Please enter the same value again.",
  accept: "Please enter a value with a valid extension.",
  maxlength: $.validator.format("Fazla rakam girdiniz."),
  minlength: $.validator.format("Eksik rakam girdiniz."),
  rangelength: $.validator.format(
    "Please enter a value between {0} and {1} characters long."
  ),
  range: $.validator.format("Please enter a value between {0} and {1}."),
  max: $.validator.format("Please enter a value less than or equal to {0}."),
  min: $.validator.format("Please enter a value greater than or equal to {0}."),
})

$("#validateForm").validate({
  submitHandler: function () {
    $successMsg.show()
  },
  highlight: function (element) {
    $(element).parent().addClass("outer-error")
  },
  unhighlight: function (element) {
    $(element).parent().removeClass("outer-error")
  },
})

const prefersDark =
  window.matchMedia && window.matchMedia("(prefers-color-scheme: Dark)").matches

if (prefersDark === true) {
  document.querySelector("body").classList.add("dark-mode")
} else {
  document.querySelector("body").classList.remove("dark-mode")
}

var app = {
  iconSpriteFn() {
    icons.forEach(iconSpriteFn)
    function iconSpriteFn(item, index) {
      const iconSprite = document.querySelector("#iconSprite")
      if (iconSprite) {
        iconSprite.innerHTML +=
          "<div class='icon-sprite__item'>" +
          "<span class='icon-sprite__number'>" +
          (index + 1) +
          "</span>" +
          "<div class='icon-sprite__preview'>" +
          item.iconSvg +
          "</div>" +
          "<div class='icon-sprite__name'>" +
          item.iconId +
          "</div>" +
          "</div>"
      }

      const icon = document.querySelectorAll(".icon")
      if (icon) {
        Array.prototype.forEach.call(icon, (el) => {
          let dataIconId = el.getAttribute("data-icon-id")
          if (dataIconId == item.iconId) {
            el.innerHTML = item.iconSvg
          }
        })
      }
    }
  },
  load() {
    console.log("load")
  },
  resized() {
    console.log("resized")
  },

  profileTopCalc() {
    var height = $(".js-calc-height").outerHeight(true) + 30
    var bottomHeight = $(".js-profile-bottom").outerHeight(true)
    $(".js-profile-bottom").css("bottom", -bottomHeight)
    $(".js-profile-content").css("margin-top", height)
    $(window).scroll(function () {
      var scroll = $(window).scrollTop()
      if (scroll >= height) {
        $(".js-profile-bottom").css("bottom", 0)
      } else {
        $(".js-profile-bottom").css("bottom", -bottomHeight)
      }
    })

    $(".js-open-modal").on("click", function () {
      $(".js-modal").addClass("active")
      var url = $(this).attr("data-qr-url")
      $(".js-modal .js-modal-attr").attr("src", url)
      var urlLink = url.split("/")
      var urlLinkLast = urlLink.slice(-1)[0]
      $(".js-modal .js-modal-attr-link").attr("href", url)
      $(".js-modal .js-modal-attr-link").attr("download", urlLinkLast)
    })
    $(".js-close-modal").on("click", function () {
      $(".js-modal").removeClass("active")
    })
  },

  alertBox(text, alertColor) {
    if ($(".alertbox").length < 1) {
      var alertBox = `<div class="alertbox"></div>`
      $("body").append(alertBox)
    }

    $(".alertbox").text(text)
    $(".alertbox").addClass(alertColor)
  },

  copyClipboard() {
    var clipboard = new ClipboardJS(".js-clipboard", {
      target: function (trigger) {
        return trigger.querySelector(".copied-el")
      },
    })
    clipboard.on("success", function (e) {
      app.alertBox("Panoya Kopyalandı: " + e.text)
      setTimeout(() => {
        $(".alertbox").fadeOut("normal", function () {
          $(this).remove()
        })
      }, 1500)
      e.clearSelection()
    })

    clipboard.on("error", function (e) {
      console.error("Action:", e.action)
    })

    $(".js-phone-mask").each(function () {
      var phone = $(this).text()
      var phoneArray = []
      phone = phone.replace(/[\n ]+/g, "")
      console.log(phone)

      var iz = -1
      if (phone[0] == "0") iz = 0
      console.log(iz)
      for (var i = 0; i < phone.length; i++) {
        var phoneS = phone.charAt(i)
        if (iz == -1 && phone[0] == "+") {
          if (phoneS == "0") iz = i
        }
        phoneArray.push(phoneS)
      }
      console.log(iz)
      console.log(phoneArray)

      if (phoneArray[0] !== "0" && phoneArray[0] != "+") {
        phoneArray.unshift("0")
      }
      if (iz == -1) iz = 0
      phoneArray.splice(1 + iz, 0, " ", "(")
      phoneArray.splice(6 + iz, 0, ")", " ")
      phoneArray.splice(11 + iz, 0, " ")
      phoneArray.splice(14 + iz, 0, " ")
      $(this).text(phoneArray.join(""))
    })
  },
  inputFocusandTexted() {
    $(".input-item input, .input-item textarea").each(function () {
      if ($(this).val() === "") {
        $(this).parent(".input-item").removeClass("input-item--valued")
      } else {
        $(this).parent(".input-item").addClass("input-item--valued")
      }
    })
    $(".input-item input, .input-item textarea").focus(function () {
      $(this).parent(".input-item").addClass("input-item--focused")
    })
    $(".input-item input, .input-item textarea").focusout(function () {
      if ($(this).val() === "") {
        $(this).parent(".input-item").removeClass("input-item--valued")
        $(this).parent(".input-item").removeClass("input-item--focused")
      } else {
        $(this).parent(".input-item").addClass("input-item--valued")
        $(this).parent(".input-item").removeClass("input-item--focused")
      }
    })
  },

  editAddSocial() {
    //     $(".js-add-social").on("click", function () {
    //       $(".js-social-input").addClass("active");
    //     });
    //     $(".js-add-top-social").on("click", function () {
    //       var selectedValue = $(".js-social-input select").val();
    //       var selectedText = $(".js-social-input select option:selected").text();
    //       var selectedInput = $(".js-social-input input").val();
    //       icons.forEach((element) => {
    //         if (selectedValue === null || selectedInput == "") {
    //           // if (selectedValue == null) {
    //           //   app.alertBox("Lütfen sosyal medya seçiniz");
    //           // } else {
    //           //   app.alertBox("Lütfen Url Giriniz");
    //           // }
    //           // setTimeout(() => {
    //           //   $(".alertbox").fadeOut("normal", function () {
    //           //     $(this).remove();
    //           //   });
    //           // }, 1500);
    //         } else if ("icon" + selectedText === element.iconId) {
    //           var appendItem = `
    //       <div class="profile__social__item" data-url="${selectedInput}"><span class="profile__social__item__edit js-profile-social-edit icon icon-font" data-icon-id="iconEdit">
    //       <svg viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
    // <path d="M1.5229 7.58115L1.68822 7.35361H1.68822L1.5229 7.58115ZM1.10809 7.16634L0.880557 7.33165L1.10809 7.16634ZM6.7271 7.58115L6.56178 7.35361L6.7271 7.58115ZM7.14191 7.16634L6.91437 7.00102V7.00102L7.14191 7.16634ZM1.10809 1.96214L0.880557 1.79683H0.880557L1.10809 1.96214ZM1.5229 1.54733L1.68822 1.77487H1.68822L1.5229 1.54733ZM3.37837 1.47317C3.53369 1.47131 3.65809 1.34389 3.65623 1.18857C3.65437 1.03325 3.52695 0.908852 3.37163 0.910714L3.37837 1.47317ZM7.77853 5.31761C7.78039 5.16229 7.65599 5.03487 7.50067 5.03301C7.34535 5.03115 7.21793 5.15555 7.21607 5.31087L7.77853 5.31761ZM4.42408 6.06591L4.39303 5.78638L4.42408 6.06591ZM2.87916 5.95436L2.68029 6.15323H2.68029L2.87916 5.95436ZM2.76761 4.40944L3.04714 4.4405L2.76761 4.40944ZM3.19778 3.51443L2.9989 3.31555L3.19778 3.51443ZM2.8661 3.90589L2.61261 3.78406H2.61261L2.8661 3.90589ZM5.3191 5.63575L5.51797 5.83462L5.3191 5.63575ZM4.92763 5.96742L5.04946 6.22091L4.92763 5.96742ZM4.125 7.65799C3.41566 7.65799 2.90625 7.65761 2.51177 7.61487C2.12255 7.5727 1.87872 7.49202 1.68822 7.35361L1.35759 7.80868C1.65996 8.02837 2.0141 8.12674 2.45118 8.17409C2.88299 8.22088 3.42819 8.22049 4.125 8.22049V7.65799ZM0.46875 4.56424C0.46875 5.26105 0.468364 5.80625 0.515148 6.23806C0.562502 6.67514 0.660871 7.02928 0.880557 7.33165L1.33563 7.00102C1.19722 6.81052 1.11654 6.56669 1.07438 6.17747C1.03164 5.78299 1.03125 5.27358 1.03125 4.56424H0.46875ZM1.68822 7.35361C1.55292 7.25531 1.43393 7.13633 1.33563 7.00102L0.880557 7.33165C1.01355 7.51471 1.17453 7.67569 1.35759 7.80868L1.68822 7.35361ZM4.125 8.22049C4.82181 8.22049 5.36701 8.22088 5.79882 8.17409C6.2359 8.12674 6.59004 8.02837 6.89241 7.80868L6.56178 7.35361C6.37128 7.49202 6.12745 7.5727 5.73823 7.61487C5.34375 7.65761 4.83434 7.65799 4.125 7.65799V8.22049ZM6.91437 7.00102C6.81607 7.13632 6.69708 7.25531 6.56178 7.35361L6.89241 7.80868C7.07547 7.67569 7.23645 7.51471 7.36944 7.33165L6.91437 7.00102ZM1.03125 4.56424C1.03125 3.8549 1.03164 3.34549 1.07438 2.95101C1.11654 2.56179 1.19722 2.31796 1.33563 2.12746L0.880557 1.79683C0.660871 2.0992 0.562502 2.45334 0.515148 2.89042C0.468364 3.32223 0.46875 3.86743 0.46875 4.56424H1.03125ZM1.35759 1.3198C1.17453 1.4528 1.01355 1.61378 0.880557 1.79683L1.33563 2.12746C1.43393 1.99216 1.55292 1.87317 1.68822 1.77487L1.35759 1.3198ZM3.37163 0.910714C2.46169 0.921622 1.8371 0.971412 1.35759 1.3198L1.68822 1.77487C2.0011 1.54755 2.44057 1.48442 3.37837 1.47317L3.37163 0.910714ZM7.21607 5.31087C7.20483 6.24867 7.14169 6.68814 6.91437 7.00102L7.36944 7.33165C7.71783 6.85214 7.76762 6.22756 7.77853 5.31761L7.21607 5.31087ZM7.13465 3.42245L5.12022 5.43687L5.51797 5.83462L7.5324 3.82019L7.13465 3.42245ZM3.39665 3.7133L5.41108 1.69887L5.01333 1.30113L2.9989 3.31555L3.39665 3.7133ZM4.39303 5.78638C3.95428 5.83513 3.65566 5.86761 3.43378 5.86045C3.21944 5.85353 3.13291 5.81035 3.07804 5.75549L2.68029 6.15323C2.88031 6.35326 3.13623 6.41363 3.41562 6.42266C3.68747 6.43143 4.03387 6.39225 4.45514 6.34544L4.39303 5.78638ZM2.48808 4.37838C2.44127 4.79966 2.40209 5.14605 2.41087 5.4179C2.41989 5.69729 2.48027 5.95321 2.68029 6.15323L3.07804 5.75549C3.02317 5.70062 2.98 5.61408 2.97307 5.39974C2.96591 5.17786 2.99839 4.87924 3.04714 4.4405L2.48808 4.37838ZM2.9989 3.31555C2.82823 3.48622 2.69348 3.6158 2.61261 3.78406L3.11959 4.02773C3.14938 3.96575 3.19886 3.91109 3.39665 3.7133L2.9989 3.31555ZM3.04714 4.4405C3.07803 4.16249 3.0898 4.08971 3.11959 4.02773L2.61261 3.78406C2.53174 3.95232 2.51474 4.13849 2.48808 4.37838L3.04714 4.4405ZM5.12022 5.43687C4.92243 5.63466 4.86777 5.68414 4.80579 5.71393L5.04946 6.22091C5.21773 6.14004 5.3473 6.00529 5.51797 5.83462L5.12022 5.43687ZM4.45514 6.34544C4.69503 6.31879 4.8812 6.30179 5.04946 6.22091L4.80579 5.71393C4.74382 5.74372 4.67104 5.75549 4.39303 5.78638L4.45514 6.34544ZM7.13465 1.69887C7.39027 1.9545 7.56156 2.12663 7.67242 2.27193C7.77833 2.41075 7.80227 2.49155 7.80227 2.56066H8.36477C8.36477 2.31911 8.26371 2.11958 8.11962 1.93073C7.98049 1.74837 7.77677 1.5455 7.5324 1.30113L7.13465 1.69887ZM7.5324 3.82019C7.77677 3.57582 7.98049 3.37295 8.11962 3.19059C8.26371 3.00174 8.36477 2.80221 8.36477 2.56066H7.80227C7.80227 2.62977 7.77833 2.71057 7.67242 2.84939C7.56156 2.99469 7.39027 3.16682 7.13465 3.42245L7.5324 3.82019ZM7.5324 1.30113C7.28802 1.05675 7.08515 0.853036 6.90279 0.7139C6.71394 0.569812 6.51441 0.46875 6.27286 0.46875V1.03125C6.34197 1.03125 6.42277 1.05519 6.56159 1.1611C6.70689 1.27196 6.87903 1.44325 7.13465 1.69887L7.5324 1.30113ZM5.41108 1.69887C5.6667 1.44325 5.83883 1.27196 5.98414 1.1611C6.12295 1.05519 6.20375 1.03125 6.27286 1.03125V0.46875C6.03131 0.46875 5.83178 0.569812 5.64293 0.7139C5.46057 0.853036 5.25771 1.05675 5.01333 1.30113L5.41108 1.69887ZM7.5324 3.42245L5.41108 1.30113L5.01333 1.69887L7.13465 3.82019L7.5324 3.42245Z"></path>
    // </svg>
    //     </span>
    //     <span class="profile__social__item__delete js-profile-social-delete icon icon-font" data-icon-id="iconEdit">
    //     <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    //     <path d="M8.53035 7.46967C8.23745 7.17677 7.76258 7.17677 7.46969 7.46967C7.17679 7.76256 7.17679 8.23743 7.46969 8.53033L8.53035 7.46967ZM11.7123 12.773C12.0052 13.0659 12.4801 13.0659 12.773 12.773C13.0659 12.4801 13.0659 12.0052 12.773 11.7123L11.7123 12.773ZM7.46969 11.7123C7.17679 12.0052 7.17679 12.4801 7.46969 12.773C7.76258 13.0659 8.23745 13.0659 8.53035 12.773L7.46969 11.7123ZM12.773 8.53033C13.0659 8.23743 13.0659 7.76256 12.773 7.46967C12.4801 7.17677 12.0052 7.17677 11.7123 7.46967L12.773 8.53033ZM3.06107 18.0451L3.50191 17.4383L3.06107 18.0451ZM1.95491 16.9389L2.56168 16.4981L1.95491 16.9389ZM18.0451 16.9389L17.4383 16.4981L18.0451 16.9389ZM16.9389 18.0451L16.4981 17.4383L16.9389 18.0451ZM16.9389 1.95491L16.4981 2.56168L16.9389 1.95491ZM18.0451 3.06107L17.4383 3.50191L18.0451 3.06107ZM3.06107 1.95491L3.50191 2.56168L3.50191 2.56168L3.06107 1.95491ZM1.95491 3.06107L2.56168 3.50191L1.95491 3.06107ZM3.13068 1.9056L2.70441 1.28851L2.70441 1.28851L3.13068 1.9056ZM16.8694 1.90569L17.2957 1.28862L17.2957 1.28862L16.8694 1.90569ZM7.46969 8.53033L9.59101 10.6516L10.6517 9.59099L8.53035 7.46967L7.46969 8.53033ZM9.59101 10.6516L11.7123 12.773L12.773 11.7123L10.6517 9.59099L9.59101 10.6516ZM8.53035 12.773L10.6517 10.6516L9.59101 9.59099L7.46969 11.7123L8.53035 12.773ZM10.6517 10.6516L12.773 8.53033L11.7123 7.46967L9.59101 9.59099L10.6517 10.6516ZM10 18.25C8.10843 18.25 6.74999 18.249 5.69804 18.135C4.66013 18.0225 4.00992 17.8074 3.50191 17.4383L2.62023 18.6518C3.42656 19.2377 4.37094 19.5 5.53648 19.6263C6.68798 19.751 8.14184 19.75 10 19.75V18.25ZM0.25 10C0.25 11.8582 0.248971 13.312 0.373728 14.4635C0.500006 15.6291 0.762324 16.5734 1.34815 17.3798L2.56168 16.4981C2.19259 15.9901 1.97745 15.3399 1.865 14.302C1.75103 13.25 1.75 11.8916 1.75 10H0.25ZM3.50191 17.4383C3.14111 17.1762 2.82382 16.8589 2.56168 16.4981L1.34815 17.3798C1.70281 17.8679 2.13209 18.2972 2.62023 18.6518L3.50191 17.4383ZM18.25 10C18.25 11.8916 18.249 13.25 18.135 14.302C18.0225 15.3399 17.8074 15.9901 17.4383 16.4981L18.6518 17.3798C19.2377 16.5734 19.5 15.6291 19.6263 14.4635C19.751 13.312 19.75 11.8582 19.75 10H18.25ZM10 19.75C11.8582 19.75 13.312 19.751 14.4635 19.6263C15.6291 19.5 16.5734 19.2377 17.3798 18.6518L16.4981 17.4383C15.9901 17.8074 15.3399 18.0225 14.302 18.135C13.25 18.249 11.8916 18.25 10 18.25V19.75ZM17.4383 16.4981C17.1762 16.8589 16.8589 17.1762 16.4981 17.4383L17.3798 18.6518C17.8679 18.2972 18.2972 17.8679 18.6518 17.3798L17.4383 16.4981ZM19.75 10C19.75 8.14184 19.751 6.68798 19.6263 5.53648C19.5 4.37094 19.2377 3.42656 18.6518 2.62023L17.4383 3.50191C17.8074 4.00992 18.0225 4.66013 18.135 5.69804C18.249 6.74999 18.25 8.10843 18.25 10H19.75ZM16.4981 2.56168C16.8589 2.82382 17.1762 3.14111 17.4383 3.50191L18.6518 2.62023C18.2972 2.13209 17.8679 1.70281 17.3798 1.34815L16.4981 2.56168ZM1.75 10C1.75 8.10843 1.75103 6.74999 1.865 5.69804C1.97745 4.66013 2.19259 4.00992 2.56168 3.50191L1.34815 2.62023C0.762324 3.42656 0.500006 4.37094 0.373728 5.53648C0.248971 6.68798 0.25 8.14184 0.25 10H1.75ZM2.62023 1.34815C2.13209 1.70281 1.70281 2.13209 1.34815 2.62023L2.56168 3.50191C2.82382 3.14111 3.14111 2.82382 3.50191 2.56168L2.62023 1.34815ZM10 0.25C8.1738 0.25 6.73872 0.249062 5.59818 0.367191C4.44603 0.486522 3.50714 0.734006 2.70441 1.28851L3.55694 2.52269C4.0652 2.17159 4.71896 1.96628 5.75271 1.85921C6.79808 1.75094 8.14216 1.75 10 1.75V0.25ZM2.70441 1.28851C2.67613 1.30805 2.64807 1.32793 2.62023 1.34815L3.50191 2.56168C3.52013 2.54844 3.53847 2.53545 3.55694 2.52269L2.70441 1.28851ZM10 1.75C11.8579 1.75 13.202 1.75094 14.2474 1.85922C15.2811 1.9663 15.9349 2.17163 16.4432 2.52275L17.2957 1.28862C16.493 0.734055 15.5541 0.486545 14.4019 0.367202C13.2614 0.249062 11.8263 0.25 10 0.25V1.75ZM16.4432 2.52275C16.4616 2.53549 16.4799 2.54846 16.4981 2.56168L17.3798 1.34815C17.352 1.32796 17.324 1.30812 17.2957 1.28862L16.4432 2.52275Z"></path>
    //     </svg>
    //     </span>
    //     <span class="profile__social__item__icon icon icon-font">
    //     ${element.iconSvg}
    //     </span><span class="txt--px12 txt--font500">${selectedText}</span></div>`;
    //           var control = true;
    //           $(".profile__social__items .profile__social__item")
    //             .find(".txt--px12")
    //             .each(function (i, value) {
    //               console.log($(value).text());
    //               if (selectedText === $(value).text()) {
    //                 control = false;
    //                 // app.alertBox("Bu sosyal medyayı daha önce eklediniz.", "red");
    //                 // setTimeout(() => {
    //                 //   $(".alertbox").fadeOut("normal", function () {
    //                 //     $(this).remove();
    //                 //   });
    //                 // }, 1500);
    //               } else {
    //                 console.log("yukarda yok");
    //               }
    //             });
    //           if (control) {
    //             $(".profile__social__items").append(appendItem);
    //             // app.alertBox("Sosyal medya başarıyla eklendi. : " + selectedInput);
    //             // setTimeout(() => {
    //             //   $(".alertbox").fadeOut("normal", function () {
    //             //     $(this).remove();
    //             //   });
    //             // }, 1500);
    //           }
    //         }
    //       });
    //     });
    //     $(".profile__social__items .profile__social__item").each(function (
    //       i,
    //       value
    //     ) {
    //       $(this)
    //         .find(".js-profile-social-edit")
    //         .click(function () {
    //           var url = $(value).attr("data-url");
    //           var text = $(value).find(".txt--px12").text().toLowerCase();
    //           $(".js-add-social").trigger("click");
    //           $(".js-profile-social-edit").removeClass("active");
    //           $(".js-profile-social-delete").removeClass("active");
    //           $(this).addClass("active");
    //           $(this).next().addClass("active");
    //           $(".js-social-input select").val(text).change();
    //           $(".js-social-input input").trigger("focus");
    //           $(".js-social-input input").val(url);
    //         });
    //       // $(this)
    //       //   .find(".js-profile-social-delete")
    //       //   .click(function () {
    //       //     $(this).closest(".profile__social__item").remove();
    //       //     $(".js-social-input select").prop("selected", false);
    //       //     $(".js-social-input input").val("");
    //       //     $(".js-social-input input").trigger("focusOut");
    //       //   });
    //     });
    $(".js-social-edit").on("click", function () {
      $(this).parent().parent().addClass("active")
    })
    $(".js-social-edit-close").on("click", function () {
      $(this).parent().parent().removeClass("active")
    })
  },
  editAddPayment() {
    $(".js-add-payment").on("click", function () {
      $(".js-payment-input").toggleClass("active")
    })
  },
  editSecurity() {
    $(".js-change-mail").on("click", function () {
      $(".js-open-mail").addClass("active")
    })
    $(".js-change-mail-close").on("click", function () {
      $(".js-open-mail").removeClass("active")
    })
    $(".js-change-password").on("click", function () {
      $(".js-open-password").addClass("active")
    })
    $(".js-change-password-close").on("click", function () {
      $(".js-open-password").removeClass("active")
    })
  },

  socialSlider() {
    const socialSwiper = new Swiper(".js-social-slider", {
      loop: false,
      slidesPerView: 3.15,
      spaceBetween: 15,
    })
  },
  catalogSlider() {
    const catalogSwiper = new Swiper(".js-catalog-slider", {
      loop: false,
      slidesPerView: 1,
      autoHeight: true,
      navigation: {
        nextEl: ".catalog-slider__right",
        prevEl: ".catalog-slider__left",
      },
      on: {
        init: function (sw) {
          var offer = document.querySelector(".js-swiper-counter")
          var offer2 = document.querySelector(".js-swiper-counterlength")
          offer.innerHTML = sw.activeIndex + 1
          offer2.innerHTML = sw.slides.length
          $(".catalog-slider__fleft").on("click", () => {
            catalogSwiper.slideTo(0, 0)
          })
          $(".catalog-slider__fright").on("click", () => {
            catalogSwiper.slideTo(sw.slides.length - 1, 0)
          })
        },
        slideChange: function (sw) {
          var offer = document.querySelector(".js-swiper-counter")
          var offer2 = document.querySelector(".js-swiper-counterlength")
          offer.innerHTML = sw.activeIndex + 1
          document.querySelector("body").scrollIntoView()
        },
      },
    })
  },

  changeColor() {
    let themeColors = document.querySelectorAll(".js-theme-items .theme__item")
    themeColors.forEach((el) => {
      el.addEventListener("click", () => {
        var color = el.getAttribute("data-color")
        let active = document.querySelectorAll(
          ".js-theme-items .theme__item.active"
        )
        active.forEach((elActive) => {
          elActive.classList.remove("active")
        })
        el.classList.add("active")
        document.documentElement.style.setProperty("--c-primary", color)
      })
    })
  },

  validateFn() {},

  showHidePassword() {
    $("body").on("click", ".js-show-hide-password", function () {
      if ($(this).hasClass("active-password")) {
        $(this).removeClass("active-password")
        $(this).parent().find("input").prop("type", "password")
      } else {
        $(this).addClass("active-password")
        $(this).parent().find("input").prop("type", "text")
      }
    })
  },

  init: function () {
    app.iconSpriteFn()
    app.load()
    app.profileTopCalc()
    app.copyClipboard()
    app.socialSlider()
    app.catalogSlider()
    app.inputFocusandTexted()
    app.editAddSocial()
    app.editAddPayment()
    app.editSecurity()
    app.validateFn()
    app.changeColor()
    app.showHidePassword()
  },
}

function docReadied(fn) {
  window.addEventListener("DOMContentLoaded", fn)
}
function docResized(fn) {
  window.addEventListener("resize", fn)
}
docReadied(() => {
  app.init()
})

docResized(() => {
  app.resized()
  app.profileTopCalc()
})

export default { docResized, docReadied }
